import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    redirect: '/tradingCenter',
    component: () => import(/* webpackChunkName: "about" */ '@/views/HomeView.vue'),
    children: [
      {
        //CA互认简介
        path: '/introduction',
        name: 'introduction',
        component: () => import(/* webpackChunkName: "about" */ '../views/introduction.vue')
      },
      {
        //新闻
        path: '/news',
        name: 'news',
        component: () => import(/* webpackChunkName: "about" */ '../views/news.vue')
      },
      {
        //互认标准
        path: '/standard',
        name: 'standard',
        component: () => import(/* webpackChunkName: "about" */ '../views/standard.vue')
      },


     

      


      {
        //常见问题
        path: '/problem',
        name: 'problem',
        component: () => import(/* webpackChunkName: "about" */ '../views/problem.vue')
      },
      

      {
        //互联交易中心
        path: '/tradingCenter',
        name: 'tradingCenter',
        component: () => import(/* webpackChunkName: "about" */ '../views/catalog/tradingCenter.vue')
      },

      {
        //电子交易系统互联目录
        path: '/tradingSystem',
        name: 'tradingSystem',
        component: () => import(/* webpackChunkName: "about" */ '../views/catalog/tradingSystem.vue')
      },


      {
        //App加入
        path: '/bidEvaluationTools',
        name: 'bidEvaluationTools',
        component: () => import(/* webpackChunkName: "about" */ '../views/catalog/bidEvaluationTools.vue')
      },

      {
        //机构加入
        path: '/venueManagementSystem',
        name: 'venueManagementSystem',
        component: () => import(/* webpackChunkName: "about" */ '../views/catalog/venueManagementSystem.vue')
      },

      {
        //场地视频会议系统互联目录
        path: '/venueVideoConferencingSystem',
        name: 'venueVideoConferencingSystem',
        component: () => import(/* webpackChunkName: "about" */ '../views/catalog/venueVideoConferencingSystem.vue')
      },

    



      
      

      {
        //场地音视频监控工具互联目录
        path: '/venueAudioAndVideoMonitoringTools',
        name: 'venueAudioAndVideoMonitoringTools',
        component: () => import(/* webpackChunkName: "about" */ '../views/catalog/venueAudioAndVideoMonitoringTools.vue')
      },

      {
        //评标专家库
        path: '/bidEvaluationExpertDatabase',
        name: 'bidEvaluationExpertDatabase',
        component: () => import(/* webpackChunkName: "about" */ '../views/catalog/bidEvaluationExpertDatabase.vue')
      },

      {
        //评标专家库
        path: '/expertExtractionTerminal',
        name: 'expertExtractionTerminal',
        component: () => import(/* webpackChunkName: "about" */ '../views/catalog/expertExtractionTerminal.vue')
      },

      



  

    


      

      

      {
        //联系我们
        path: '/contactUs',
        name: 'contactUs',
        component: () => import(/* webpackChunkName: "about" */ '../views/contactUs.vue')
      },


    

      {
        //常见问题
        path: '/askedQuestion',
        name: 'askedQuestion',
        component: () => import(/* webpackChunkName: "about" */ '../views/askedQuestion.vue')
      },


      {
        //常见问题
        path: '/testedit',
        name: 'testedit',
        component: () => import(/* webpackChunkName: "about" */ '../views/testedit.vue')
      },


     




      

      

      
      
      
    ]
  },
  

  
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
